import React from "react";
// import { NavLink } from 'react-router-dom';
import Avatar from '@material-ui/core/Avatar';
import profileBanner from '../../../assets/images/images/profile-bg.png'
// import database from "../../../database/database"

class ProfileHeader extends React.Component {
  render() {
    // const server = database.serverURL.includes('web')
    return (
      <div className="jr-profile-banner" style={{ backgroundImage: `url(${profileBanner})`, backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize: 'cover', paddingTop: '70px' }}>
        <div className="jr-profile-container">
          <div className="jr-profile-banner-top">
            <div className="jr-profile-banner-top-left">
              <div className="jr-profile-banner-avatar">
                <Avatar className="size-90" alt="..." src={this.props.profilePic} />
              </div>
              <div className="jr-profile-banner-avatar-info">
                <h2 className="mb-2 jr-mb-sm-3 jr-fs-xxl jr-font-weight-light">{this.props.name}</h2>
                <p className="mb-0 jr-fs-lg">{this.props.location}</p>
              </div>
            </div>
          </div>
          {/* {
            server ? <div className="jr-profile-banner-bottom">
              <NavLink className="jr-profile-setting" style={{ color: '#fff' }} to={`/app/profile/edit`}>
                <span className="nav-link  mr-4">
                  <i className="zmdi zmdi-edit mr-1" />
                  <span className="d-inline-flex align-middle ml-1 jr-ml-sm-0">Edit Profile</span>
                </span>
              </NavLink>
            </div> : ''
          } */}


        </div>
      </div>
    )
  }
}
export default ProfileHeader;

